module.exports = __webpack_public_path__ + "static/Hostmeapp-059f701a2d9817fe3b814c782ea7d9a8.svg";